// src/beta/hooks/useAutoAdvance.ts
import { useEffect, useRef } from 'react';
import { useReducedMotion } from '@/beta/hooks/useReducedMotion';

interface UseAutoAdvanceOptions {
  onAdvance: () => void;
  intervalMs: number;
  paused: boolean;
}

/** Calls `onAdvance` every `intervalMs` while not paused.
 *  Disabled entirely when prefers-reduced-motion is matched.
 *  See spec § 6.5: attract loop pauses if reduced motion. */
export function useAutoAdvance({ onAdvance, intervalMs, paused }: UseAutoAdvanceOptions) {
  const reduced = useReducedMotion();
  const cb = useRef(onAdvance);
  cb.current = onAdvance;

  useEffect(() => {
    if (paused || reduced) return;
    const id = window.setInterval(() => cb.current(), intervalMs);
    return () => window.clearInterval(id);
  }, [paused, reduced, intervalMs]);
}
